import styled from '@emotion/styled';
import { GlobalDataType } from 'common/apiService';
import { Link } from 'common/styles';
import { __t } from 'common/i18n';
import { getNavigationUrl } from 'common/utils';
import { useRouter } from 'next/router';

const LinksList = styled.ul(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(1, 0),
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    padding: 0,
    width: 'auto',
    height: '100%',
    flexDirection: 'row',
  },
}));

const ListItem = styled.li<{ active?: boolean }>(({ theme, active }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 0),
  marginRight: theme.spacing(2),
  borderBottom: active ? '1px solid hsl(349, 66%, 40%)' : '1px solid transparent',
  '&:hover': {
    borderBottom: '1px solid hsl(349, 66%, 40%)',
  },
  [theme.breakpoints.down('md')]: {
    borderBottom: '1px solid transparent',
    '&:hover': {
      borderBottom: '1px solid transparent',
    },
  },
}));

export default function MenuLinks({ className = '', data = {} }: { className?: string; data?: GlobalDataType }) {
  const router = useRouter();
  return (
    <LinksList className={className}>
      <>
        <ListItem className="mobile-only">
          <Link href="/contents?types=single_video">{__t('content.type.movie')}</Link>
        </ListItem>
        <ListItem className="mobile-only">
          <Link href="/contents?types=series">{__t('content.type.tv_show')}</Link>
        </ListItem>
      </>
      <ListItem active={router.asPath === '/categories'}>
        <Link href="/categories">{__t('common.category')}</Link>
      </ListItem>
      {data.links && data.links?.[0]?.items.map(({ id, configuration, display_title }) => {
        const url = getNavigationUrl(configuration, display_title) ?? '#';
        return <ListItem key={id} active={url !== '#' && router.asPath.includes(url)}>
          <Link href={url}>{display_title}</Link>
        </ListItem>;
      })}
    </LinksList>
  );
}
